<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center">
        <v-col cols="12" sm="auto">
          <v-dialog v-model="editor" max-width="480">
            <template #activator="{ on, attr }">
              <v-btn text color="primary" v-bind="attr" v-on="on">
                <v-icon left>mdi-plus</v-icon>
                Создать
              </v-btn>
            </template>
            <key-editor v-model="item" @close="close" @save="save" />
          </v-dialog>
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto" class="d-flex align-center">
          <v-text-field
            v-model="search"
            :style="searchStyle"
            hide-details
            clearable
            single-line
            prepend-icon="mdi-magnify"
            placeholder="Поиск по ключам..."
          />
          <v-btn icon @click="load">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-data-table
      dense
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="id"
      @click:row="open"
    >
      <template #item.code="{ item }">
        {{ formatIdentifier(item.code) }}
      </template>
      <template #item.actions="{ item }">
        <v-btn icon @click.stop="toggleArchival(item)">
          <v-icon v-if="item.archival" color="success"
            >mdi-archive-arrow-up</v-icon
          >
          <v-icon v-else color="error">mdi-archive-arrow-down-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import KeyEditor from "@/components/keys/KeyEditor.vue";
import { formatIdentifier } from "@/utils/format-identifier";
import {
  findKeys,
  createKey,
  updateKey,
  setArchival
} from "@/services/keys.service";
import { withNotifications } from "@/utils/notifications";

export default {
  components: { KeyEditor },

  data() {
    return {
      headers: [
        { text: "Название", value: "name" },
        { text: "Идентификатор", value: "code", filterable: true },
        { text: "Описание", value: "description" },
        { text: "Цвет", value: "color" },
        { text: "Действия", value: "actions" }
      ],
      items: [],
      item: {},

      search: null,
      loading: false,
      editor: false
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    searchStyle() {
      return this.isMobile ? "max-width: 100%" : "max-width: 320px";
    }
  },

  created() {
    this.load();
  },

  watch: {
    editor(opened) {
      if (!opened) this.item = {};
    },

    search() {
      this.load();
    }
  },

  methods: {
    formatIdentifier,

    async load() {
      this.loading = true;
      await withNotifications(async () => {
        this.items = await findKeys(this.search);
      });
      this.loading = false;
    },

    save(key) {
      withNotifications(async () => {
        if (key.id) {
          await updateKey(key);
        } else {
          await createKey(key);
        }
        this.load();
      });
    },

    toggleArchival(item) {
      withNotifications(async () => {
        await setArchival(item, !item.archival);
        this.load();
      });
    },

    open(item) {
      this.item = item;
      this.editor = true;
    },

    close() {
      this.editor = false;
    }
  }
};
</script>
